import qpiatoImg from '../../../assets/qpiato.png'


export default function QPiatoLoading() {
    return (
        <div className="absolute z-[200] bg-white text-black h-full w-full
        flex justify-center items-center
        ">
            <div className="animate-pulse flex justify-center items-center w-full">
                <img className="max-w-[50%]" src={qpiatoImg} />
            </div>
        </div>
    )
}